import { AppColors } from "../../assets/styles/colors";

export const componentStyles = {

  fixFooter: {
    position: "fixed",
    width: "100%",
    bottom: 0,
  },
  logoStyle: {
    width: "55%",
    height: "55%",
    display: "flex",
    justifyContent: "center", 
  },
  outer:{
    height: "100dvh",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  inner:{
    height: "75%",
    width: "90%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  rowStyle: {
    display: "flex",
    alignItems: "end",
    height: "100%",
    overflow: "hidden",
  },
  signInHeading: {
    fontFamily: "OpenSans-Variable",
    fontSize: "36px",
    color: AppColors.newBlue,
    fontWeight: 500,
    lineHeight: "68px",
    justifyContent: "center", 
  },
  signInDescription: {
    fontFamily: "OpenSans-Variable",
    fontSize: "15px",
    color: AppColors.lightBlue,
    fontWeight: 500,
    lineHeight: "19.8px",
    justifyContent: "center",
  },
  signInButton: {
    width: "40%",
    backgroundColor: "#E65088",
    fontFamily: "OpenSans-Variable",
    borderColor: "#E65088",
    marginBottom: "3px",
  },
  
  SignupLink: {
    color: "#000000",
  },
  SignupLink2: {
    marginTop: "3px",
    color: "#4D83EF",
  },
  forgotPasswordLink: {
    color: "#000000",
  },
  forgotPasswordLink2: {
    color: "#4D83EF",
  },
  formInput: {
    marginTop: "30px",
    margin: "0 auto",
  },
  centerFormButton: {
    textAlign: "center",
    paddingTop: "0.5rem",
  },
  marginAuto: {
    margin: "0 auto",
  },
  loginImageStyle: {
    width: "100vw",
    height: "100vh",
    objectFit: "contain",
  },
  logoinLogoStyle: {
    width: "35vh",
  },
  privacyPolicyTextStyle: {
    fontSize: "9px",
    textAlign: "justify",
  },
  formBody: {
    margin: "0px"
  },
  flexCenter: {
    justifyContent: "center",
    textAlign: "center",
  },
  
};
